import styled from 'styled-components';
import { spacing, colors, caption, Label, Monospace2 } from 'ui/theme';
import { pxToRem } from 'utils/convert';
import { GhostSuccessButton, SecondaryButton } from 'ui/button';

import { BasicSelect } from 'ui/selects';

import type { CollapsableRowProps } from '../types';

export const Monospace = styled(Monospace2)`
  background-color: inherit;
`;

export const CheckboxField = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: ${spacing.half} 0 0 0;
  & [role='checkbox'] {
    margin-right: ${spacing.half};
  }
  cursor: pointer;
`;

export const FormSection = styled.div`
  width: 100%;
  margin-top: ${spacing.single};
  margin-bottom: ${spacing.plusHalf};
`;

export const BasicAuthSection = styled(FormSection)`
  margin-top: ${spacing.base};
  margin-bottom: 0;
`;

export const OAuthSection = styled(FormSection)`
  margin-top: ${spacing.base};
  margin-bottom: 0;
  display: grid;
  grid-auto-flow: row dense;
  grid-template-columns: ${pxToRem(300)} ${pxToRem(300)};
  gap: ${spacing.base} ${spacing.plusHalf};

  > :nth-child(1) {
    grid-area: 1 / span 1;
  } /* client id */
  > :nth-child(2) {
    grid-area: 1 / span 1;
    margin-top: 0;
  } /* client secret */
  > :nth-child(3) {
    grid-area: 2 / span 2;
    margin-top: 0;
  } /* token url */
`;

export const AuthenticationSelect = styled(BasicSelect)`
  width: ${spacing.x12};
`;

export const BodySelect = styled(BasicSelect)`
  width: ${spacing.x12};
`;

export const AceEditorWrapper = styled.div`
  border: 1px solid ${colors.grey15};
  margin-top: ${spacing.plusHalf};

  .ace_gutter {
    z-index: 2;
  }
`;

export const CollapsableGridRow = styled.div<CollapsableRowProps>`
  height: ${(props) => (props.collapsed ? 0 : 'inherit')};
  visibility: ${(props) => (props.collapsed ? 'hidden' : 'visible')};
  margin-bottom: ${spacing.plusHalf};
`;

export const Caption = styled.span`
  ${caption};
  color: ${colors.textSecondary};
`;

export const Hint = styled.div`
  ${caption};
  color: ${colors.textSecondary};
  line-height: ${spacing.double};
`;

export const AddButtonLabel = styled.span`
  display: inline-block;
  margin-left: ${spacing.half};
`;

export { Label };

export const WorkflowWebhookForm = styled.div`
  margin-top: -${spacing.plusHalf};
  width: ${pxToRem(702)};

  display: grid;
  grid-auto-flow: row dense;
  grid-template-columns: ${spacing.x8} ${spacing.x4} ${spacing.x16} ${spacing.x7};
  gap: 0 ${spacing.plusHalf};

  > :nth-child(1) {
    grid-area: 1 / span 4;
  } /* name */
  > :nth-child(2) {
    grid-area: 2 / span 3;
  } /* destination */
  > :nth-child(3) {
    grid-area: 3 / span 1;
  } /* method */
  > :nth-child(4) {
    grid-area: 3 / span 3;
  } /* endpoint */
  > :nth-child(5) {
    grid-area: 4 / span 4;
  } /* authentication */
  > :nth-child(6) {
    grid-area: 5 / span 4;
  } /* customHeaders */
  > :nth-child(7) {
    grid-area: 6 / span 4;
  } /* contentType */
  > :nth-child(8) {
    grid-area: 7 / span 4;
  } /* save/update button */
`;

export const AddButton = styled(GhostSuccessButton)`
  margin-left: ${spacing.quarter};
  margin-top: ${spacing.half};
`;

export const CancelButton = styled(SecondaryButton)`
  margin-left: ${spacing.base};
`;
